var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"goal-lock-btn"},_vm.$listeners),[_c('span',{staticClass:"material-icons goal-lock-btn__icon",class:{'goal-lock-btn__icon--locked': _vm.locked}},[_vm._v(" lock ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }